'use strict'

function getRules() {
    return {
        category: [
            { required: true, message: '请选择分类', trigger: ['change', 'blur'] },
        ],
        company: [
            { required: true, message: '请选择所属公司', trigger: ['change', 'blur'] },
        ],
        title: [
            // { required: true, message: '请填写名称', trigger: ['blur', 'change'] },
            { required: true, message: '请填写名称', trigger: 'blur' },
        ],
        department: [
            { required: true, message: '请选择所属部门', trigger: ['change', 'blur'] },
        ],
        owner: [
            { required: true, message: '请填写拥有者', trigger: ['change', 'blur'] },
        ],
        user: [
            { required: true, message: '请填写使用者', trigger: ['blur', 'change'] },
        ]
    }
}
export {
    getRules
}
